
// import "./PricingPlan.css"; // Ensure appropriate styling
import React, { useState, useEffect, useContext } from "react";
import { PartenerSheepDeedService } from "../services/parternshipservice";
import CitySelector from "./User/CitySelectore";
import { handleRazorpayPayment } from "../services/handlePayment";
import AuthUser from "../services/AuthUser";
import { ServicesContext } from "../services/ServicesContext";
import { useNavigate } from "react-router-dom";

const PricingPlanPro = ({ tenures, requirements, price, inclusions, title, onSubmit }) => {

    useEffect(() => {
        const storedUser = localStorage.getItem("user");
        if (storedUser) {
            const parsedUser = JSON.parse(storedUser);
            setNewData((prevData) => ({
                ...prevData,
                user_name: parsedUser.name || "",
                user_email: parsedUser.email || "",
                user_contact: parsedUser.mobile || "",
                user_city: parsedUser.city || "",
            }));
        }
    }, []);


    const [isDropdownOpen, setIsDropdownOpen] = useState(false);
    const [selectedTenure, setSelectedTenure] = useState(null);

    const { http, token } = AuthUser();
    const navigate = useNavigate();
    const { services, loading, error } = useContext(ServicesContext);
    const service = services.find(s => s.service_id === 18);
    // Track if the bottom content is visible
    // State to store selected values
    const [formData, setFormData] = useState({
        transactions: "",
        accounting: "",
        accountingFor: "",
    });

    // Handle changes for all dropdowns
    const handleChange = (event) => {
        const { name, value } = event.target;
        setFormData((prevState) => ({
            ...prevState,
            [name]: value,
        }));
    };



    const toggleDropdown = () => setIsDropdownOpen((prev) => !prev);

    const selectTenure = (tenure) => {
        setSelectedTenure(tenure);
        setIsDropdownOpen(false);  // Close dropdown after selection
    };

    // Close dropdown if clicked outside
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (event.target.closest('.dropdown') === null) {
                setIsDropdownOpen(false);  // Close dropdown when clicking outside
            }
        };

        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);



    const [formVisible, setFormVisible] = useState(false);



    const toggleFormVisibility = () => {
        setFormVisible(!formVisible);
    };


    const [newData, setNewData] = useState({ plans: title, prize: price, user_name: '', user_email: '', user_contact: '', user_city: '' })


    const [errors, setErrors] = useState({});

    const validateForm = () => {
        const newErrors = {};



        if (!newData.user_name.trim()) {
            newErrors.user_name = '*Name is required.';
        } else if (!/^[a-zA-Z\s]+$/.test(newData.user_name)) {
            newErrors.user_name = '*Name should only contain letters and spaces.';
        }

        if (!newData.user_email.trim()) {
            newErrors.user_email = '*Email is required.';
        } else if (!/\S+@\S+\.\S+/.test(newData.user_email)) {
            newErrors.user_email = 'Enter a valid email address.';
        }

        // if (newData.user_contact && !/^\d{10}$/.test(newData.user_contact)) {
        //     newErrors.user_contact = '*Enter a valid 10-digit contact number.';
        // }

        if (!newData.user_contact.trim()) {
            newErrors.user_contact = '*number is required.';
        } else if (!/^\d{10}$/.test(newData.user_contact)) {
            newErrors.user_contact = 'Enter a valid 10-digit contact number.';
        }

        if (!newData.user_city) {
            newErrors.user_city = '*City/District is required.';
        }
        if (!formData.transactions.trim()) {
            newErrors.transactions = "*Transactions field is required.";
        }
        if (!formData.accounting.trim()) {
            newErrors.accounting = "*Accounting field is required.";
        }
        if (!formData.accountingFor.trim()) {
            newErrors.accountingFor = "*Accounting For field is required.";
        }

        setErrors(newErrors);
        return Object.keys(newErrors).length === 0; // No errors
    };

    const currentData = {
        select_tenure: JSON.stringify(formData), // Convert to JSON string
        plans: title,
        prize: price,
        user_name: newData.user_name,
        user_email: newData.user_email,
        user_contact: newData.user_contact,
        user_city: newData.user_city,
    };




    const handleSubmit = async (e) => {
        e.preventDefault(); // Prevent form default behavior

        // ✅ Check if user is logged in
        // if (!token) {
        //     alert("Please log in to continue.");
        //     localStorage.setItem("redirectAfterLogin", window.location.pathname); // ⬅️ Save current path
        //     navigate('/login'); // 👈 Use this if you're using React Router
        //     return;
        // }
        if (validateForm()) {
            try {
                //  const currentData = {
                //      select_tenure: JSON.stringify(formData), // Convert to JSON string
                //      plans: title,
                //      prize: price,
                //      user_name: newData.user_name,
                //      user_email: newData.user_email,
                //      user_contact: newData.user_contact,
                //      user_city: newData.user_city,
                //  };
                //  console.log("Submitting data:", currentData);
                //  const data = await PartenerSheepDeedService.onlineAccountingForm(currentData);
                //  // Reset form
                //  setFormData({
                //      transactions: "",
                //      accounting: "",
                //      accountingFor: "",
                //  });

                //  setNewData({
                //      plans: title,
                //      prize: price,
                //      select_tenure: '',
                //      user_name: '',
                //      user_email: '',
                //      user_contact: '',
                //      user_city: '',
                //  });

                localStorage.setItem("bookingData", JSON.stringify(currentData));

                // Navigate to checkout
                navigate('/checkout', {
                    state: {
                        service: service,

                    }
                });
                if (onSubmit) {
                    onSubmit(currentData); // Pass the constructed data to the parent
                }
            } catch (error) {
                console.log(error);
            }
        }

    };

    return (
        <div className="pricing-plan pro">
            <div className="price">
                <p className="pp-text">{title}</p>
                {formVisible && (
                    <div className="wrapper">
                        <button className="getStartdBn btn" onClick={toggleFormVisibility}>
                            Close
                        </button>
                    </div>
                )}

            </div>
            {/* <p className="price-section">
        <span>Start From</span>Rs.<span>/Only</span>
      </p> */}
            <div className="p-content">


                {formVisible ? (
                    <div className="formContainer">
                        <form>
                            <div className="form-group">
                                <label className="text-bold" htmlFor="name">
                                    Name
                                </label>{errors.user_name && <p className="error">{errors.user_name}</p>}
                                <input type="text" className="form-control" required value={newData.user_name} onChange={(e) => setNewData({ ...newData, user_name: e.target.value })} />
                            </div>
                            <div className="form-group">
                                <label className="text-bold" htmlFor="email">
                                    Email
                                </label>{errors.user_email && <p className="error">{errors.user_email}</p>}
                                <input type="email" className="form-control" required value={newData.user_email} onChange={(e) => setNewData({ ...newData, user_email: e.target.value })} />
                            </div>
                            <div className="form-group">
                                <label className="text-bold" htmlFor="mobile">
                                    Contact no
                                </label> {errors.user_contact && <p className="error">{errors.user_contact}</p>}
                                <input type="tel" className="form-control" required value={newData.user_contact} onChange={(e) => setNewData({ ...newData, user_contact: e.target.value })} />
                            </div>
                            {/* Transactions Dropdown */}
                            <div className="form-group">
                                <label className="text-bold" htmlFor="transactions">
                                    Please select annual transactions
                                </label><br /> {errors.transactions && <p className="error">{errors.transactions}</p>}
                                <select className="dropdown" id="transactions" name="transactions" onChange={handleChange} value={formData.transactions}>
                                    <option value="" hidden>Select an option</option>
                                    <option value="0 to 500 Transactions">0 to 500 Transactions</option>
                                    <option value="500 to 1200 Transactions">500 to 1200 Transactions</option>
                                    <option value="1200 to 2500 Transactions">1200 to 2500 Transactions</option>
                                    <option value="2500 to 5000 Transactions">2500 to 5000 Transactions</option>
                                    <option value="5000 to 7500 Transactions">5000 to 7500 Transactions</option>
                                    <option value="More Than 7500">More Than 7500</option>
                                </select>
                            </div>

                            {/* Accounting Dropdown */}
                            <div className="form-group">
                                <label className="text-bold" htmlFor="accounting">
                                    Accounting
                                </label>{errors.accounting && <p className="error">{errors.accounting}</p>}
                                <select className="dropdown" id="accounting" name="accounting" onChange={handleChange} value={formData.accounting}>
                                    <option value="" hidden>Select an option</option>
                                    <option value="Accounting with Inventory">Accounting with Inventory</option>
                                    <option value="Accounting without Inventory">Accounting without Inventory</option>
                                </select>
                            </div>

                            {/* Accounting For Dropdown */}
                            <div className="form-group">
                                <label className="text-bold" htmlFor="accountingFor">
                                    Accounting for
                                </label> <br />  {errors.accountingFor && <p className="error">{errors.accountingFor}</p>}
                                <select className="dropdown" id="accountingFor" name="accountingFor" onChange={handleChange} value={formData.accountingFor}>
                                    <option value="" hidden>Select an option</option>
                                    <option value="Accounting for Service Provider">Accounting for Service Provider</option>
                                    <option value="Accounting Supervision / Checking">Accounting Supervision / Checking</option>
                                    <option value="Accounting Consultancy">Accounting Consultancy</option>
                                </select>
                            </div>
                            <div className="form-group">
                                <CitySelector
                                    newData={newData}
                                    setNewData={setNewData}
                                    fieldKey="user_city"
                                    errors={errors}
                                />
                            </div>

                            <div class="wrapper">
                                <button type="submit" className="getStartdBn btn" onClick={handleSubmit}>
                                    Submit
                                </button>
                            </div>
                        </form>
                    </div>
                ) : (
                    <div className="yttt">
                        <div className="accordion">

                            <AccordionSection

                                title="Included Invoice Marking :-"
                                content={[
                                    "Sales Invoice",
                                    "Service Invoice",
                                ]}

                            />
                            <AccordionSection

                                title="Included Transactions"
                                content={[
                                    "Sales and Purchase Invoice",
                                    "Service Invoice",
                                    "Cash and Bank Entries",
                                    "Income and Expenses Entries",
                                    "All Other Financial Transactions",
                                ]}

                            />
                            <AccordionSection

                                title="Balance Enquiry"
                                content={[
                                    "Cash Balance",
                                    "Party Ledger Balance",
                                    "Party Last Transaction",
                                    "Sales and Purchase Figures",
                                    "Taxation Liability Balance",
                                ]}

                            />
                            <AccordionSection

                                title="Reconciliation"
                                content={["Bank Accounts", "Loan Accounts", "Party Accounts on Demand"]}

                            />
                            <AccordionSection

                                title="Ledger and Statement"
                                content={[
                                    "Party Ledger on Demand",
                                    "Tax Liability Ledger on Demand",
                                    "Stock Statement on Demand",
                                ]}

                            />
                            <AccordionSection

                                title="Included Reports"
                                content={["Trial Balance", "Balance Sheet", "Profit and Loss Account"]}

                            />
                            <AccordionSection
                                title="More"
                                content={[
                                    "E-way bill facility",
                                    "Dashboard for managing service",
                                    "Mobile application support",
                                    "Documents sharing facility",
                                    "Download deliverables any time",
                                    "Password sharing",
                                    "Round the clock support",
                                    "Time to time updates & notifications",
                                ]}
                            />
                            <div className="accordion-section" >
                                <div className="accordion-title-2"><p><span ><i className="fa fa-star icone"></i> Book Finanalization</span></p>  </div>
                            </div>
                            <div className="space101"></div>
                            <div className="accordion-section" >
                                <div className="accordion-title-2"><p><span ><i className="fa fa-star icone"></i> Yearly Book of Accounts(PDF)</span></p>  </div>
                            </div>
                            <div className="space101"></div>
                            <div className="accordion-section" >
                                <div className="accordion-title-2"><p><span ><i className="fa fa-star icone"></i> Yearly Book of Accounts(Hard Copy)</span></p>  </div>
                            </div>
                        </div>
                        <div class="wrapper">
                            <button className="getStartdBn btn" onClick={toggleFormVisibility}>
                                {formVisible ? "X" : "Get Started"}
                            </button>
                        </div>
                    </div>


                )}
            </div>


        </div>
    );
};

const AccordionSection = ({ title, content }) => {
    const [isOpen, setIsOpen] = useState(false);

    const toggleAccordion = () => {
        setIsOpen(!isOpen);
    };

    return (
        <div className={`accordion-section ${isOpen ? "active" : ""}`}>
            <div className="accordion-title" onClick={toggleAccordion}>
                <p>
                    <span>
                        <i className="fa fa-star icone"></i> {title}
                    </span>
                </p>
            </div>
            <div className={`accordion-content ${isOpen ? "active" : ""}`}>
                {content.map((item, index) => (
                    <p key={index} className="text-bold">
                        <img src="assets/icons/check.svg" alt="" /> {item}
                    </p>
                ))}
            </div>
        </div>
    );
};

export default PricingPlanPro;
